import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUsersAsync } from '../../../features/users/usersActions';
import { selectAllUsers, selectCanManageUsers } from '../../../features/users/usersSlice';
const UsersContext = createContext(null);
export function UsersProvider({ children }) {
  const dispatch = useDispatch();
  const users = useSelector(selectAllUsers);
  const registry = useSelector(state => state.users.registry);
  const canManage = useSelector(selectCanManageUsers);
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('');
  const [page, setPage] = useState(1);
  const reload = useCallback(() => dispatch(getUsersAsync()), [dispatch]);
  useEffect(() => { const request = reload(); return () => request.abort(); }, [reload]);
  const filteredUsers = useMemo(() => {
    const query = search.trim().toLowerCase();
    return users.filter(user => (!status || user.status === status) &&
      [user.fullName, user.employeeId, user.email, user.role?.name].some(value => String(value || '').toLowerCase().includes(query)))
      .sort((a, b) => a.fullName.localeCompare(b.fullName));
  }, [users, search, status]);
  const stats = useMemo(() => ({
    total: users.length,
    admins: users.filter(user => user.role?.name === 'ADMIN').length,
    managers: users.filter(user => user.role?.name === 'MANAGER').length,
    staff: users.filter(user => user.role?.name === 'STAFF').length,
    inactive: users.filter(user => user.status === 'INACTIVE').length,
  }), [users]);
  const totalPages = Math.max(1, Math.ceil(filteredUsers.length / 10));
  const currentPage = Math.min(page, totalPages);
  const updateSearch = value => { setSearch(value); setPage(1); };
  const updateStatus = value => { setStatus(value); setPage(1); };
  return <UsersContext.Provider value={{ users, stats, canManage, search, setSearch: updateSearch,
    status, setStatus: updateStatus, page: currentPage, setPage, totalPages,
    filteredCount: filteredUsers.length, visibleUsers: filteredUsers.slice((currentPage - 1) * 10, currentPage * 10),
    loading: registry.loading || !registry.requestId, error: registry.error, reload }}>{children}</UsersContext.Provider>;
}
export function useUsers() {
  const context = useContext(UsersContext);
  if (!context) throw new Error('useUsers requires UsersProvider.');
  return context;
}
